import React, { Fragment } from 'react';
import { validate } from "../../Common"
import { PageHeader } from '../../../Common';

export const Card = ({title, buttonEnabled, butonText, path, fields, onSubmit, schema, data}) => {
    return ( 
        <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader 
                                    title={title} 
                                    isButtonEnable={buttonEnabled} 
                                    buttonText={butonText} 
                                    path={path} 
                                />
                            </div>
                            <hr />
                            <form onSubmit={(e) => onSubmit(e)}>
                                {fields}
                                <input 
                                    type="submit" 
                                    className="btn btn-primary" 
                                    value="Save" 
                                />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
     );
}